// extracted by mini-css-extract-plugin
module.exports = {"ingress":"Articles_ingress__9lnHf","clamp-2":"Articles_clamp-2__4WEna","clamp-5":"Articles_clamp-5__XlFra","article":"Articles_article__5LL9g"};